unit Search.FMSSuppliers;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls;

type
  TfrmSearsFMSSupplier = class(TWebForm)
    WebPanel1: TWebPanel;
    WebPanel2: TWebPanel;
    WebPanel3: TWebPanel;
    WebButton1: TWebButton;
    WebButton2: TWebButton;
    weSearch: TWebEdit;
    dgSearch: TTMSFNCDataGrid;
    dgdbaSearch: TTMSFNCDataGridDatabaseAdapter;
    wcSearch: TXDataWebClient;
    wdsSearch: TXDataWebDataSet;
    dsSearch: TWebDataSource;
    wdsSearchautono: TIntegerField;
    wdsSearchDepotname: TStringField;
    wdsSearchsuppliercode: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure dgSearchCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iAutoFMSDepot : Integer;
    sFMSDepotName : String;
  end;

var
  frmSearsFMSSupplier: TfrmSearsFMSSupplier;

implementation

{$R *.dfm}
uses
  stfmssystem.connection;

procedure TfrmSearsFMSSupplier.dgSearchCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaSearch.SetActiveRecord(ARow);
  iAutoFMSDepot := dgdbaSearch.FieldAtColumn[0].AsInteger;
  sFMSDepotName := dgdbaSearch.FieldAtColumn[1].AsString;
end;

procedure TfrmSearsFMSSupplier.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSearsFMSSupplier.WebButton2Click(Sender: TObject);
begin
  sFMSDepotName := '';
  iAutoFMSDepot := -1;
  Close;
end;

procedure TfrmSearsFMSSupplier.WebFormShow(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSearch.Close;
      wdsSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSearch.Open;
    end;

begin
  wcSearch.RawInvoke('IstfmsdieselService.Get_FMSDepots_View',['*'],@OnSuccess);
end;

procedure TfrmSearsFMSSupplier.weSearchChange(Sender: TObject);
begin
   if weSearch.Text <> '' then
    begin
      case dgSearch.Selection.StartCell.Column of
        0 : wdsSearch.Locate('autono', weSearch.Text, [loPartialKey]);
        1 : wdsSearch.Locate('Depotname', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

end.